import { RotateCcw, Truck, Ban, ShieldAlert } from "lucide-react";
import { usePageMeta } from "@/hooks/usePageMeta";

const POLICIES = [
  { icon: RotateCcw, title: "Returns after delivery", text: "Returns are only initiated after the buyer has received the product. Open a return from your dashboard once the item arrives." },
  { icon: Truck, title: "Buyer pays return shipping", text: "For standard returns, the buyer is responsible for paying the return shipping costs." },
  { icon: Ban, title: "No cancellations", text: "Orders cannot be cancelled once they have been placed. Please review your purchase carefully before checking out." },
  { icon: ShieldAlert, title: "Misrepresented listings", text: "If an item is misrepresented in the listing, the seller will cover both the return shipping and the full price of the product." },
];

export default function ReturnPolicy() {
  usePageMeta(
    "Return Policy | Beauty Trade Club",
    "Read the Beauty Trade Club return policy. Learn how escrow protection, disputes, refunds and return shipping work for buyers and sellers.",
    "/returns"
  );
  return (
    <div className="max-w-3xl mx-auto px-6 py-16">
      <div className="text-center mb-12">
        <RotateCcw className="text-[#E8956B] mx-auto mb-4" size={32} />
        <h1 className="font-display text-4xl sm:text-5xl font-black">Return Policy</h1>
        <p className="text-neutral-600 mt-4 max-w-xl mx-auto">
          We want every trade to feel safe and fair. Here's how returns work on Beauty Trade Club.
        </p>
      </div>

      <div className="space-y-4">
        {POLICIES.map((p, i) => (
          <div key={i} className="flex gap-4 bg-white border border-neutral-200 rounded-2xl p-6">
            <div className="w-11 h-11 shrink-0 rounded-full bg-[#E8956B]/15 flex items-center justify-center">
              <p.icon className="text-[#E8956B]" size={20} />
            </div>
            <div>
              <h3 className="font-bold text-lg">{p.title}</h3>
              <p className="text-neutral-600 mt-1 leading-relaxed">{p.text}</p>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-10 rounded-2xl bg-[#E8956B]/10 border border-[#E8956B]/30 p-6 text-sm text-neutral-700 leading-relaxed">
        <strong className="text-neutral-900">Escrow protection:</strong> Because payments are held in escrow until you confirm
        receipt (or 7 days after shipment), you're covered if an item never arrives or is misrepresented. If there's an issue,
        use <span className="font-semibold">"Report an issue"</span> on your order and our team will review it before any funds
        are released to the seller.
      </div>
    </div>
  );
}
